module.exports = __webpack_public_path__ + "img/about_logo_05.4cc8de9b.png";